const ErrorEventCollectionFields = [
	{
		ID: "CreatedOn",
		Label: "Created On",
	},
];

export default ErrorEventCollectionFields;